// ── Shared filter button renderer ─────────────────────────────────────────────
// Renders filter buttons into a desktop nav and a mobile popout.
// Call this from each gallery module's _renderFilterButtons().

let _outsideHandler = null;

function getOrCreate(tag, id) {
    let el = document.getElementById(id);
    if (!el) { el = document.createElement(tag); el.id = id; document.body.appendChild(el); }
    return el;
}

function btnHtml(key, label, active) {
    return `<button class="filter-btn filter-padding uppercase${active ? ' underline underline-offset-4' : ''}" data-filter="${key}">${label}</button>`;
}

export function renderFilterButtons(nav, groups, activeFilter, onSelect, { includeAll = true } = {}) {
    const all = includeAll ? [{ key: 'all', label: 'All' }, ...groups] : [...groups];

    // Desktop nav
    if (nav) nav.innerHTML = all.map(({ key, label }) => btnHtml(key, label, key === activeFilter)).join('');

    // Mobile launcher + popout (created once, reused)
    const launcher = getOrCreate('button', 'filter-launcher');
    const popout   = getOrCreate('div',    'filter-popout');

    popout.innerHTML = all.map(({ key, label }) => btnHtml(key, label, key === activeFilter)).join('');

    const activeLabel = all.find(g => g.key === activeFilter)?.label ?? 'Filters';
    launcher.textContent = (includeAll && activeFilter === 'all') ? 'Filters' : activeLabel;

    // Wire clicks in both containers
    [nav, popout].forEach(container => {
        if (!container) return;
        container.querySelectorAll('.filter-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const key   = btn.dataset.filter;
                const label = all.find(g => g.key === key)?.label ?? 'Filters';
                // Sync active state across both containers
                [nav, popout].forEach(c => {
                    if (!c) return;
                    c.querySelectorAll('.filter-btn').forEach(b => {
                        b.classList.toggle('underline',          b.dataset.filter === key);
                        b.classList.toggle('underline-offset-4', b.dataset.filter === key);
                    });
                });
                launcher.textContent = (includeAll && key === 'all') ? 'Filters' : label;
                launcher.classList.toggle('is-filtered', key !== 'all');
                onSelect(key);
                closePopout(launcher, popout);
            });
        });
    });

    // Launcher toggle
    launcher.onclick = () => {
        popout.classList.contains('is-open') ? closePopout(launcher, popout) : openPopout(launcher, popout);
    };

    // Outside click — re-register each time to pick up new popout reference
    if (_outsideHandler) document.removeEventListener('click', _outsideHandler);
    _outsideHandler = e => {
        if (popout.classList.contains('is-open') && !popout.contains(e.target) && e.target !== launcher) {
            closePopout(launcher, popout);
        }
    };
    document.addEventListener('click', _outsideHandler);
}

function openPopout(launcher, popout) {
    popout.classList.add('is-open');
    launcher.classList.add('is-open');
}

function closePopout(launcher, popout) {
    popout.classList.remove('is-open');
    launcher.classList.remove('is-open');
}

// The launcher/popout live on document.body (outside swup's container), so they
// persist across navigation and would otherwise linger on filterless pages.
// Call this at the start of each navigation; the new page's gallery recreates
// them if it needs them.
export function removeFilterUI() {
    document.getElementById('filter-launcher')?.remove();
    document.getElementById('filter-popout')?.remove();
    if (_outsideHandler) {
        document.removeEventListener('click', _outsideHandler);
        _outsideHandler = null;
    }
}
